/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DevGrantSubscriptionDto } from '../models/DevGrantSubscriptionDto';
import type { PromoCodeValidationResponseDto } from '../models/PromoCodeValidationResponseDto';
import type { RedeemPromoCodeResponseDto } from '../models/RedeemPromoCodeResponseDto';
import type { TesterGrantRequestDto } from '../models/TesterGrantRequestDto';
import type { TesterGrantResponseDto } from '../models/TesterGrantResponseDto';
import type { ValidatePromoCodeRequestDto } from '../models/ValidatePromoCodeRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BillingService {
    /**
     * Check if user is a tester and grant subscription for selected plan
     * Checks if the current user email is in the tester_yearly_grant feature flag. If yes, grants a RevenueCat entitlement and creates the database subscription with credits for the selected product.
     * @param requestBody
     * @returns TesterGrantResponseDto
     * @throws ApiError
     */
    public static billingControllerCheckTesterGrantV1(
        requestBody: TesterGrantRequestDto,
    ): CancelablePromise<TesterGrantResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/check-tester-grant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * [Dev only] Directly create subscription + credits without RevenueCat webhook
     * Bypasses the RevenueCat webhook flow by creating the subscription record and granting credits directly. Only available in non-production environments.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static billingControllerDevGrantSubscriptionV1(
        requestBody: DevGrantSubscriptionDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/dev/grant-subscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Not available in production`,
            },
        });
    }
    /**
     * [Dev only] Run the annual credit reset sweep immediately
     * Triggers the hourly annual-plan monthly credit reset sweep on demand instead of waiting for the cron tick. Only available in non-production environments.
     * @returns any
     * @throws ApiError
     */
    public static billingControllerDevRunAnnualCreditResetV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/dev/run-annual-credit-reset',
            errors: {
                403: `Not available in production`,
            },
        });
    }
    /**
     * Check whether a promo code can be redeemed by the current user
     * Read-only: no counters are touched. Returns the benefit shape (type/tier/duration/campaign) for display.
     * @param requestBody
     * @returns PromoCodeValidationResponseDto
     * @throws ApiError
     */
    public static promoCodeControllerValidatePromoCodeV1(
        requestBody: ValidatePromoCodeRequestDto,
    ): CancelablePromise<PromoCodeValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/promo-codes/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Redeem a promo code for the current user
     * free_access codes grant the entitlement directly (like the tester grant); discount codes return the RevenueCat offering to swap the paywall to.
     * @param requestBody
     * @returns RedeemPromoCodeResponseDto
     * @throws ApiError
     */
    public static promoCodeControllerRedeemPromoCodeV1(
        requestBody: ValidatePromoCodeRequestDto,
    ): CancelablePromise<RedeemPromoCodeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/promo-codes/redeem',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
